module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "pgmonospaced"
  }, [_c('br', {
    staticClass: "calibre1"
  })]), _vm._v(" "), _c('h1', {
    staticClass: "calibre2",
    attrs: {
      "id": "pgepubid00000"
    }
  }, [_vm._v("THE FIFTH BATTALION"), _c('br', {
    staticClass: "calibre3"
  }), _vm._v("\n  HIGHLAND LIGHT INFANTRY"), _c('br', {
    staticClass: "calibre3"
  }), _vm._v("\n  IN THE WAR")]), _vm._v(" "), _c('h3', {
    staticClass: "sigilnotintoc sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00001"
    }
  }, [_vm._v("1914-1918")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    staticClass: "calibre4",
    attrs: {
      "alt": "morrison",
      "src": "Images/img00001.jpg"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "illus01"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("COLONEL F.L. MORRISON, C.B., D.S.O., V.D.")]), _vm._v(" "), _c('h3', {
    staticClass: "sigilnotintoc sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00002"
    }
  }, [_vm._v("The Fifth Battalion")]), _vm._v(" "), _c('h2', {
    staticClass: "sigilnotintoc1 sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00003"
    }
  }, [_vm._v("Highland Light Infantry"), _c('br', {
    staticClass: "calibre3"
  }), _vm._v("\n  in the War")]), _vm._v(" "), _c('h4', {
    staticClass: "sigilnotintoc2 sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00004"
    }
  }, [_vm._v("1914-1918")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("TO THE MEMORY OF")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("THE OFFICERS, WARRANT OFFICERS,")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("NON-COMMISSIONED OFFICERS AND MEN OF")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("THE FIFTH BATTALION HIGHLAND LIGHT INFANTRY")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("WHO FELL IN THE WAR 1914-1918")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6540914","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0001.vue
// module id = 57
// module chunks = 0